export default "__VITE_ASSET__DlVnQAp8__"